// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1U0Gh","header":"MergedInvoice_header__3bBMM"};